import { AdminMemberReportPDF } from './AdminMemberReportPDF';

export default AdminMemberReportPDF;